module.exports = __webpack_public_path__ + "assets/img/pizza_4.dc05e9c5.png";